import React from 'react';

import { Badge } from './ui/badge';
import { humanizeKey } from '../lib/labels';
import { cn } from '../lib/utils';
import { STATUS_REGISTRY, STATUS_TONE_FILL, type StatusStyle } from '../lib/statusRegistry';

interface StatusBadgeProps {
  /** Raw domain status, matched case-insensitively against the registry. */
  status: string;
  /**
   * Adds context to the registry label ("Live v1.4", "3 in review"). Must keep
   * the state's own word — never substitute another state's word.
   */
  label?: string;
  className?: string;
}

/** An unregistered status is assumed to be runtime state: muted, with a dot. */
const FALLBACK_STYLE: StatusStyle = { variant: 'muted', dot: true };

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, label, className }) => {
  const key = status.trim().toLowerCase();
  const style = STATUS_REGISTRY[key] ?? FALLBACK_STYLE;
  const text = label ?? style.label ?? humanizeKey(status.trim());

  return (
    <Badge variant={style.variant} className={className}>
      {style.dot ? (
        <span
          aria-hidden="true"
          // The same fill a row stripe or legend swatch reads (statusTone).
          className={cn('h-1.5 w-1.5 rounded-full', STATUS_TONE_FILL[style.variant])}
        />
      ) : null}
      {text}
    </Badge>
  );
};
